// eslint-disable-next-line import/no-cycle
import {
  ConfigurationPanelStructure,
  ConfigurationPanelStructureItemEnum,
  TemplateStructureEnum,
  TabItem,
  ElementPositionEnum,
  CloseIconPositionValueEnum,
  CloseIconListEnum,
  ComponentNameEnum,
  StepperSignEnum,
  BackgroundImageOptionTypeEnum,
  AppearEffectEnum,
} from '@/types';
// eslint-disable-next-line import/no-cycle
import boxShadowFieldConfig from '@/components/template-builder/config/fields/box-shadow-config';
// eslint-disable-next-line import/no-cycle
import getColorFieldConfig from '@/components/template-builder/config/fields/color-config';
// eslint-disable-next-line import/no-cycle
import getWidthFieldConfig from '@/components/template-builder/config/fields/width-config';
// eslint-disable-next-line import/no-cycle
import getTeaserWidthFieldConfig from '@/components/template-builder/config/fields/teaser-width-config';
// eslint-disable-next-line import/no-cycle
import {
  setCssProperty,
  setCssPropertyAndRemoveIfZero,
  setCssPropertyWithImportant,
  setBackgroundImage,
  setBackgroundImageProperty,
  setClass,
  setPositionClass,
  setTeaserWidth,
  setMediaDisplay,
} from '@/components/template-builder/setters';
// eslint-disable-next-line import/no-cycle
import {
  getBackgroundCssProperty,
  getClassByName,
  getCssPropertyByName,
  isVisible,
} from '@/components/template-builder/getters';
// eslint-disable-next-line import/no-cycle
import getDropdownFieldConfig from '@/components/template-builder/config/fields/dropdown-config';
// eslint-disable-next-line import/no-cycle
import getVerticalSpacesFieldConfig from '@/components/template-builder/config/fields/vertical-spaces-config';
// eslint-disable-next-line import/no-cycle
import getHorizontalSpacesFieldConfig from '@/components/template-builder/config/fields/horizontal-spaces-config';
// eslint-disable-next-line import/no-cycle
import getTopBorderRadiusFieldConfig from '@/components/template-builder/config/fields/top-border-radius-config';
// eslint-disable-next-line import/no-cycle
import getBottomBorderRadiusFieldConfig from '@/components/template-builder/config/fields/bottom-border-radius-config';
// eslint-disable-next-line import/no-cycle
import { adjustTeaserWidthForShape } from '@/components/template-builder/callbacks';
// eslint-disable-next-line import/no-cycle
import bordersFieldConfig from '@/components/template-builder/config/fields/borders-config';
// eslint-disable-next-line import/no-cycle
import getBackgroundImageFieldConfig from '@/components/template-builder/config/fields/background-image-config';
// eslint-disable-next-line import/no-cycle
import getIconsFieldConfig from '@/components/template-builder/config/fields/icons-config';
// eslint-disable-next-line import/no-cycle
import getDisplayFieldConfig from '@/components/template-builder/config/fields/display-config';
// eslint-disable-next-line import/no-cycle
import getStepperFieldConfig from '@/components/template-builder/config/fields/stepper-config';
// eslint-disable-next-line import/no-cycle
import getPositionGridFieldConfig from '@/components/template-builder/config/fields/position-grid-config';
// eslint-disable-next-line import/no-cycle
import { getTemplateIframeDocument } from '@/components/template-builder/utils/helpers';
// eslint-disable-next-line import/no-cycle
import mediaDisplayFieldConfig from '@/components/template-builder/config/fields/media-display-config';
// eslint-disable-next-line import/no-cycle
import contentVerticalAlignFieldConfig from '@/components/template-builder/config/fields/content-vertical-align-config';

export const pageTabItemConfig: TabItem = {
  type: ConfigurationPanelStructureItemEnum.TAB_ITEM,
  tabItemType: TemplateStructureEnum.PAGE,
  label: 'templateBuilder.configs.page',
  tabPanel: {
    label: 'templateBuilder.configs.page',
    items: [
      {
        type: ConfigurationPanelStructureItemEnum.TAB_ITEM,
        tabItemType: TemplateStructureEnum.GROUP,
        label: 'templateBuilder.configs.styles',
        scrollable: true,
        tabPanel: {
          items: [
            {
              type: ConfigurationPanelStructureItemEnum.FIELDS_GROUP,
              label: 'templateBuilder.configs.pageAppearance',
              selector: 'body #spm_body',
              items: [
                {
                  label: 'templateBuilder.fields.displayShape',
                  selector: '#spm_body.spm_teaser',
                  fieldId: 'teaserDisplayShape',
                  properties: [
                    {
                      name: 'spm_shape_',
                      getter: getClassByName,
                      setters: [setClass],
                      callbacks: [adjustTeaserWidthForShape],
                    },
                  ],
                  ...getDropdownFieldConfig(
                    [
                      { value: 'rectangle', label: 'templateBuilder.fields.displayShapes.rectangle' },
                      { value: 'circle', label: 'templateBuilder.fields.displayShapes.circle' },
                    ],
                    'rectangle',
                  ),
                  displayToggle: false,
                },
                {
                  label: 'templateBuilder.fields.backgroundColor',
                  selector:
                    '#spm_body.spm_teaser #spm_content, #spm_body #spm_content',
                  properties: [
                    {
                      name: 'background',
                      getter: getBackgroundCssProperty,
                      setters: [setCssPropertyWithImportant],
                    },
                  ],
                  ...getColorFieldConfig('#ffffff', true, true),
                  displayToggle: true,
                },
                {
                  label: 'templateBuilder.fields.backgroundImage',
                  selector:
                    '#spm_body.spm_teaser #spm_content, #spm_body #spm_content',
                  properties: [
                    {
                      name: 'background-image',
                      getter: getCssPropertyByName,
                      setters: [setBackgroundImage],
                    },
                    {
                      name: 'background-size',
                      getter: getCssPropertyByName,
                      setters: [setBackgroundImageProperty],
                    },
                    {
                      name: 'background-position-x',
                      getter: getCssPropertyByName,
                      setters: [setBackgroundImageProperty],
                    },
                    {
                      name: 'background-position-y',
                      getter: getCssPropertyByName,
                      setters: [setBackgroundImageProperty],
                    },
                    {
                      name: 'background-repeat',
                      getter: getCssPropertyByName,
                      setters: [setBackgroundImageProperty],
                    },
                  ],
                  ...getBackgroundImageFieldConfig(BackgroundImageOptionTypeEnum.FULL),
                },
                {
                  label: 'templateBuilder.fields.width',
                  selector: '#spm_body.spm_teaser #spm_content',
                  properties: [
                    {
                      name: 'width',
                      getter: getCssPropertyByName,
                      setters: [setTeaserWidth],
                    },
                    {
                      name: 'min-width',
                      getter: getCssPropertyByName,
                      setters: [setTeaserWidth],
                    },
                  ],
                  ...getTeaserWidthFieldConfig(250),
                  displayToggle: false,
                },
                {
                  label: 'templateBuilder.fields.borders',
                  selector: '#spm_body #spm_content',
                  properties: [
                    {
                      name: 'border-color',
                      getter: getCssPropertyByName,
                      setters: [setCssProperty],
                    },
                    {
                      name: 'border-style',
                      getter: getCssPropertyByName,
                      setters: [],
                    },
                    {
                      name: 'border-width',
                      getter: getCssPropertyByName,
                      setters: [setCssPropertyAndRemoveIfZero],
                    },
                    {
                      name: 'border-top-color',
                      getter: getCssPropertyByName,
                      setters: [],
                    },
                    {
                      name: 'border-top-width',
                      getter: getCssPropertyByName,
                      setters: [],
                    },
                    {
                      name: 'border-top-style',
                      getter: getCssPropertyByName,
                      setters: [setCssProperty],
                    },
                    {
                      name: 'border-bottom-color',
                      getter: getCssPropertyByName,
                      setters: [],
                    },
                    {
                      name: 'border-bottom-width',
                      getter: getCssPropertyByName,
                      setters: [],
                    },
                    {
                      name: 'border-bottom-style',
                      getter: getCssPropertyByName,
                      setters: [setCssProperty],
                    },
                    {
                      name: 'border-left-color',
                      getter: getCssPropertyByName,
                      setters: [],
                    },
                    {
                      name: 'border-left-width',
                      getter: getCssPropertyByName,
                      setters: [],
                    },
                    {
                      name: 'border-left-style',
                      getter: getCssPropertyByName,
                      setters: [setCssProperty],
                    },
                    {
                      name: 'border-right-color',
                      getter: getCssPropertyByName,
                      setters: [],
                    },
                    {
                      name: 'border-right-width',
                      getter: getCssPropertyByName,
                      setters: [],
                    },
                    {
                      name: 'border-right-style',
                      getter: getCssPropertyByName,
                      setters: [setCssProperty],
                    },
                  ],
                  ...bordersFieldConfig,
                },
                {
                  label: 'templateBuilder.fields.borderRadius',
                  selector: '#spm_body.spm_teaser #spm_content',
                  parentFieldId: 'teaserDisplayShape',
                  isVisible: (items: any[], parentFieldId: string) => {
                    const parentField = items.find((item: any) => item.fieldId === parentFieldId);
                    if (!parentField) return true;
                    const template = getTemplateIframeDocument();
                    if (!template) return true;
                    const spmBody = template.querySelector('#spm_body.spm_teaser') as HTMLElement;
                    return !spmBody?.classList.contains('spm_shape_circle');
                  },
                  properties: [
                    {
                      name: 'border-top-left-radius',
                      getter: getCssPropertyByName,
                      setters: [setCssPropertyAndRemoveIfZero],
                    },
                    {
                      name: 'border-top-right-radius',
                      getter: getCssPropertyByName,
                      setters: [setCssPropertyAndRemoveIfZero],
                    },
                    {
                      name: 'border-bottom-left-radius',
                      getter: getCssPropertyByName,
                      setters: [setCssPropertyAndRemoveIfZero],
                    },
                    {
                      name: 'border-bottom-right-radius',
                      getter: getCssPropertyByName,
                      setters: [setCssPropertyAndRemoveIfZero],
                    },
                  ],
                  componentName: ComponentNameEnum.SPACES,
                  options: {
                    ...getTopBorderRadiusFieldConfig().options,
                    ...getBottomBorderRadiusFieldConfig().options,
                  },
                },
                {
                  label: 'templateBuilder.fields.boxShadow',
                  selector: '#spm_body.spm_teaser #spm_content',
                  properties: [
                    {
                      name: 'box-shadow',
                      getter: getCssPropertyByName,
                      setters: [setCssProperty],
                    },
                  ],
                  ...boxShadowFieldConfig,
                },
                {
                  label: 'templateBuilder.fields.verticalAlignment',
                  selector: '#spm_body.spm_teaser #spm_content',
                  properties: [
                    {
                      name: 'align-content',
                      getter: getCssPropertyByName,
                      setters: [setCssProperty],
                    },
                  ],
                  ...contentVerticalAlignFieldConfig,
                  displayToggle: false,
                },
                {
                  label: 'templateBuilder.fields.appearEffect',
                  selector: '#spm_body.spm_teaser',
                  properties: [
                    {
                      name: 'spmEffect_',
                      getter: getClassByName,
                      setters: [setClass],
                    },
                  ],
                  ...getDropdownFieldConfig(
                    Object.values(AppearEffectEnum).map((effect) => ({
                      label: effect,
                      value: effect,
                    })),
                    AppearEffectEnum.NONE,
                  ),
                  displayToggle: false,
                },
              ],
            },
            {
              type: ConfigurationPanelStructureItemEnum.FIELDS_GROUP,
              label: 'templateBuilder.configs.pageCloseButton',
              selector: 'body #spm_body.spm_teaser',
              items: [
                {
                  label: 'templateBuilder.fields.displayCloseIcon',
                  selector: '#spm_body.spm_teaser .spm_close_button',
                  properties: [
                    {
                      name: 'display',
                      getter: getCssPropertyByName,
                      setters: [setCssPropertyWithImportant],
                    },
                  ],
                  ...getDisplayFieldConfig(
                    'display',
                    'inline-block',
                    'none',
                    'inline-block',
                  ),
                  displayToggle: false,
                  fieldId: 'displayCloseIcon',
                  enableValue: 'inline-block',
                },
                {
                  label: 'templateBuilder.fields.closeIconPosition',
                  selector: '#spm_body.spm_teaser .spm_close_button',
                  properties: [
                    {
                      name: 'spm_closeposition_',
                      getter: getClassByName,
                      setters: [setClass],
                    },
                  ],
                  ...getDropdownFieldConfig(
                    Object.values(CloseIconPositionValueEnum).map((position) => ({
                      value: position,
                      label: `templateBuilder.fields.positions.${position}`,
                    })),
                    CloseIconPositionValueEnum.TOP_RIGHT,
                  ),
                  displayToggle: false,
                  parentFieldId: 'displayCloseIcon',
                  isVisible,
                },
                {
                  label: 'templateBuilder.fields.closeIconPositionMargin',
                  selector: '#spm_body.spm_teaser .spm_close_button',
                  properties: [
                    {
                      name: 'margin',
                      getter: getCssPropertyByName,
                      setters: [setCssPropertyAndRemoveIfZero],
                    },
                  ],
                  ...getStepperFieldConfig(StepperSignEnum.PX),
                  displayToggle: true,
                  parentFieldId: 'displayCloseIcon',
                  isVisible,
                },
                {
                  label: 'templateBuilder.fields.closeIconStyle',
                  selector: '#spm_body.spm_teaser .spm_close_button',
                  properties: [
                    { name: 'spm_icon-', getter: getClassByName, setters: [setClass] },
                  ],
                  ...getIconsFieldConfig(
                    Object.values(CloseIconListEnum),
                    'spm_icon-',
                    'cancel-1',
                  ),
                  displayToggle: false,
                  parentFieldId: 'displayCloseIcon',
                  isVisible,
                },
                {
                  label: 'templateBuilder.fields.closeIconColor',
                  selector: '#spm_body.spm_teaser #spm_content a.spm_close_button',
                  properties: [
                    {
                      name: 'color',
                      getter: getCssPropertyByName,
                      setters: [setCssPropertyWithImportant],
                    },
                  ],
                  ...getColorFieldConfig('#000000'),
                  displayToggle: false,
                  parentFieldId: 'displayCloseIcon',
                  isVisible,
                },
              ],
            },
            {
              type: ConfigurationPanelStructureItemEnum.FIELDS_GROUP,
              label: 'templateBuilder.configs.teaserPositioning',
              selector: 'body #spm_body',
              items: [
                {
                  label: 'templateBuilder.fields.teaserPosition',
                  selector: '#spm_body.spm_teaser',
                  properties: [
                    {
                      name: 'spm_position_',
                      getter: getClassByName,
                      setters: [setPositionClass],
                    },
                  ],
                  ...getPositionGridFieldConfig('bl'),
                },
                {
                  label: 'templateBuilder.fields.adjustTeaserPosition',
                  selector: '#spm_body.spm_teaser',
                  properties: [
                    {
                      name: 'margin-top',
                      getter: getCssPropertyByName,
                      setters: [setCssPropertyAndRemoveIfZero],
                    },
                    {
                      name: 'margin-bottom',
                      getter: getCssPropertyByName,
                      setters: [setCssPropertyAndRemoveIfZero],
                    },
                    {
                      name: 'margin-left',
                      getter: getCssPropertyByName,
                      setters: [setCssPropertyAndRemoveIfZero],
                    },
                    {
                      name: 'margin-right',
                      getter: getCssPropertyByName,
                      setters: [setCssPropertyAndRemoveIfZero],
                    },
                  ],
                  componentName: ComponentNameEnum.SPACES,
                  options: {
                    ...getVerticalSpacesFieldConfig('margin').options,
                    ...getHorizontalSpacesFieldConfig('margin').options,
                  },
                },
                {
                  label: 'templateBuilder.fields.mediaDisplay',
                  selector: '#spm_body.spm_teaser',
                  properties: [
                    {
                      name: 'show-for-',
                      getter: getClassByName,
                      setters: [setMediaDisplay],
                    },
                  ],
                  ...mediaDisplayFieldConfig,
                },
              ],
            },
          ],
        },
      },
      {
        type: ConfigurationPanelStructureItemEnum.FIELDS_GROUP,
        label: 'templateBuilder.configs.pageMargins',
        selector: 'body #spm_body.spm_teaser',
        items: [
          {
            label: 'templateBuilder.fields.contentInnerMargins',
            selector: '#spm_body.spm_teaser #spm_content',
            properties: [
              {
                name: 'padding-top',
                getter: getCssPropertyByName,
                setters: [setCssPropertyAndRemoveIfZero],
              },
              {
                name: 'padding-bottom',
                getter: getCssPropertyByName,
                setters: [setCssPropertyAndRemoveIfZero],
              },
              {
                name: 'padding-left',
                getter: getCssPropertyByName,
                setters: [setCssPropertyAndRemoveIfZero],
              },
              {
                name: 'padding-right',
                getter: getCssPropertyByName,
                setters: [setCssPropertyAndRemoveIfZero],
              },
            ],
            componentName: ComponentNameEnum.SPACES,
            options: {
              ...getVerticalSpacesFieldConfig('padding').options,
              ...getHorizontalSpacesFieldConfig('padding').options,
            },
          },
          {
            label: 'templateBuilder.fields.widgetInnerMargins',
            selector: '#spm_body.spm_teaser .spm_widget',
            properties: [
              {
                name: 'padding-top',
                getter: getCssPropertyByName,
                setters: [setCssPropertyAndRemoveIfZero],
              },
              {
                name: 'padding-bottom',
                getter: getCssPropertyByName,
                setters: [setCssPropertyAndRemoveIfZero],
              },
              {
                name: 'padding-left',
                getter: getCssPropertyByName,
                setters: [setCssPropertyAndRemoveIfZero],
              },
              {
                name: 'padding-right',
                getter: getCssPropertyByName,
                setters: [setCssPropertyAndRemoveIfZero],
              },
            ],
            componentName: ComponentNameEnum.SPACES,
            options: {
              ...getVerticalSpacesFieldConfig('padding').options,
              ...getHorizontalSpacesFieldConfig('padding').options,
            },
          },
        ],
      },
    ],
  },
};

const teaserPageConfig: ConfigurationPanelStructure = {
  items: [pageTabItemConfig],
};

export default teaserPageConfig;
